import useFunnels, { UseFunnelReturn } from "@/hooks/useFunnels";
import { createContext, PropsWithChildren, useContext } from "react";

const FunnelsContext = createContext<UseFunnelReturn | null>(null);

export const FunnelsProvider = ({ children }: PropsWithChildren) => {
    const funnelData = useFunnels();

    return (
        <FunnelsContext.Provider value={funnelData}>
            {children}
        </FunnelsContext.Provider>
    );
};

export const useFunnelsContext = (): UseFunnelReturn => {
    const context = useContext(FunnelsContext);
    if (!context) throw new Error("FunnelsContext must be used within FunnelsProvider");
    return context;
};